/* @flow */
import * as React from 'react';
import { css, names } from 'linaria';

import Colors from '../../constants/Colors';
import Title from './Title';
import BodyText from './BodyText';

const ThemeMap = {
  light: {
    titleColor: Colors.Black,
    textColor: Colors.GrayAlt1,
  },
  dark: {
    titleColor: Colors.White,
    textColor: Colors.IndigoLight,
  },
};

const InlineFeature = ({
  title,
  description,
  icon,
  style,
  className,
  theme = 'light',
}: {
  title: string,
  description: string,
  icon?: any,
  style?: Object,
  className?: string,
  theme?: 'dark' | 'light',
}) => {
  const ThemeStyles = ThemeMap[theme];

  return (
    <div className={names(Styles.Root, className)} style={style}>
      {icon && <div style={{ minHeight: 110 }}>{icon}</div>}
      <Title size="20" align="center" weight="bold" color={ThemeStyles.titleColor}>
        {title}
      </Title>
      <BodyText size="14" color={ThemeStyles.textColor}>
        {description}
      </BodyText>
    </div>
  );
};

export default InlineFeature;

const Styles = {
  Root: css`
    margin-bottom: 0;
    margin-left: auto;
    margin-right: auto;
    margin-top: 0;
    padding: 0 20px;
    text-align: center;
  `,
};



// WEBPACK FOOTER //
// ./src/ui/components/core/InlineFeature.js